'use client';

import { usePathname } from 'next/navigation';

// Use Set for O(1) lookup performance
const NO_CHROME_PAGES_SET = new Set([
  '/mortgage-lead-generation-demo',
  '/pricing',
  '/mortgage-marketing-pricing',
  '/mortgage-lead-generation-demo/thank-you',
  '/pricing/thank-you',
  '/demo-form-next', // internal routes the middleware rewrites the new form's public URLs to
  '/demo-form-next/thank-you',
  '/demo-form-next/pricing',
  '/demo-form-next/pricing/thank-you',
  '/mortgage-lead-generation-demo-redesign', // hidden concept build of the demo experience
  '/mortgage-lead-generation-demo-redesign/thank-you',
  '/mortgage-lead-generation-demo-redesign-2', // hidden game-concept build of the demo experience
  '/mortgage-lead-generation-demo-redesign-2/thank-you',
  '/ad-gallery',
  '/redesign-tracker',
  '/admin',
  '/rebel-iq-ai',
  '/ai',
  '/calculators',
  '/gauntlet',
]);

interface ConditionalNavigationProps {
  children: React.ReactNode;
}

export default function ConditionalNavigation({ children }: ConditionalNavigationProps) {
  const pathname = usePathname();

  // Direct computation - no state, no effects, no double render
  if (NO_CHROME_PAGES_SET.has(pathname)) {
    return null;
  }

  // Conversion Analyzer reports are a full-screen app with their own top bar
  if (pathname?.startsWith('/conversion-analyzer-preview/r/')) {
    return null;
  }

  // Hidden Growth Report previews live under a secret path segment
  if (pathname?.startsWith('/growth-report-preview')) {
    return null;
  }

  // Hide navigation for OG preview pages (used for screenshot generation)
  if (pathname?.startsWith('/og-preview/')) {
    return null;
  }

  // Hide navigation for all admin routes
  if (pathname?.startsWith('/admin')) {
    return null;
  }

  return <>{children}</>;
}